export default "__VITE_ASSET__Cazj$C50__"